import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { ROLES_CREATE_PERMISSION } from "../../permissions";

const RolesAccessControl = ({ children }) => (
    <ComponentAccessControl baseResources={ROLES_CREATE_PERMISSION}>
        {children}
    </ComponentAccessControl>
);

export default RolesAccessControl;
